export const IMAGE_STYLE_OPTIONS = [
  { value: "flat", label: "Flat Illustration" },
  { value: "isometric", label: "Isometric" },
  { value: "realistic", label: "Realistic" },
];

export const ImageStyleSelector = ({ testIdPrefix, style, onChangeStyle, onRegenerateAll, regenerating, hasAiImages }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-image-style-selector`}>
    <label className="text-xs font-bold uppercase tracking-[0.1em] text-slate-400 dark:text-slate-500">AI Image Style</label>
    <select
      value={style}
      onChange={(e) => onChangeStyle(e.target.value)}
      data-testid={`${testIdPrefix}-image-style-select`}
      className="rounded-lg border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-700 dark:border-white/15 dark:bg-white/5 dark:text-white"
    >
      {IMAGE_STYLE_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
    <button
      type="button"
      onClick={onRegenerateAll}
      disabled={regenerating || !hasAiImages}
      data-testid={`${testIdPrefix}-regenerate-all-btn`}
      title={hasAiImages ? "" : "No AI-generated images to regenerate yet"}
      className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-bold text-slate-600 hover:bg-slate-50 disabled:opacity-40 dark:border-white/15 dark:text-slate-200 dark:hover:bg-white/10"
    >
      {regenerating ? "Regenerating…" : "Regenerate All AI Images"}
    </button>
  </div>
);
